export default __webpack_public_path__ + "static/media/logo.7d6f08a3.svg";